import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './TermsAndPrivacy.module.css';

const TermsAndPrivacy = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // 根据 hash 滚动到对应区域
  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.replace('#', ''));
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
      }
    }
  }, [location.hash]);

  return (
    <div className={styles.wrapper}>
      <header className={styles.header}>
        <button
          type="button"
          className={styles.backBtn}
          onClick={() => navigate(-1)}
          aria-label="返回上一页"
        >
          <span className={`material-symbols-outlined ${styles.backIcon}`}>arrow_back</span>
        </button>
        <h1 className={styles.title}>服务条款与隐私政策</h1>
      </header>

      <main className={styles.content}>
        {/* ========== 服务条款 ========== */}
        <section className={styles.section} id="terms">
          <div className={styles.sectionIcon}>
            <span className="material-icons-outlined">gavel</span>
          </div>
          <h2 className={styles.sectionTitle}>服务条款</h2>
          <p className={styles.updateDate}>最后更新日期：2025 年 6 月 1 日</p>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>1. 服务概述</h3>
            <p className={styles.text}>
              欢迎使用我们的英语阅读学习平台（以下简称"本平台"）。本平台为用户提供中文小说的AI翻译英文版、单词收藏、句子收藏、AI 笔记、音频播放等学习服务。使用本平台即表示您同意遵守以下条款。
            </p>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>2. 账户注册与安全</h3>
            <ul className={styles.list}>
              <li>您必须提供真实、准确、完整的注册信息。</li>
              <li>您有责任保管好自己的账户密码，因密码泄露导致的损失由您自行承担。</li>
              <li>每个账户仅限本人使用，不得转让、出借或共享。</li>
              <li>如您发现账户存在异常，请及时联系我们。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>3. VIP 会员服务与付费</h3>
            <ul className={styles.list}>
              <li>本平台提供月度和年度 VIP 会员订阅服务。</li>
              <li>所有付款通过 <strong>Stripe</strong> 安全支付平台处理。本平台不直接存储您的信用卡或借记卡信息。</li>
              <li>订阅价格以下单页面显示的价格为准，我们保留调整价格的权利，价格变更将在下一个计费周期生效。</li>
              <li>VIP 会员权益自付款成功后立即生效，有效期根据您选择的套餐而定。</li>
              <li>会员到期后，如未续费，您的账户将恢复为免费用户状态，部分功能将受到限制。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>4. 退款政策</h3>
            <ul className={styles.list}>
              <li>由于数字服务的即时交付性质，付款成功后原则上不予退款。</li>
              <li>如您在付款后 24 小时内未使用任何 VIP 专属功能，可申请全额退款。</li>
              <li>退款申请请通过应用内反馈或邮件联系我们的客服团队。</li>
              <li>退款将通过原支付渠道（Stripe）退回，处理时间通常为 5–10 个工作日。</li>
              <li>因用户个人原因（如忘记取消续费等）导致的扣费，不在退款范围内。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>5. 订阅管理</h3>
            <ul className={styles.list}>
              <li>您可以随时在个人中心管理您的订阅状态。</li>
              <li>取消订阅后，当前计费周期内的 VIP 权益仍然有效，到期后自动降级为免费用户。</li>
              <li>如果您使用了 Stripe 提供的自动续费功能，请注意在到期前取消，以避免自动扣款。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>6. 知识产权</h3>
            <ul className={styles.list}>
              <li>本平台所有内容（包括但不限于文本、音频、翻译、AI 笔记、界面设计）均受版权保护。</li>
              <li>用户不得未经授权复制、转载、传播本平台的任何内容。</li>
              <li>用户在本平台创建的个人笔记、收藏记录等数据归用户个人所有。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>7. 用户行为规范</h3>
            <ul className={styles.list}>
              <li>禁止使用自动化工具批量抓取或下载平台内容。</li>
              <li>禁止传播违法、淫秽、侮辱性或侵犯他人权益的内容。</li>
              <li>禁止干扰或破坏平台正常运行。</li>
              <li>违反上述规范的账户，我们有权暂停或终止其服务，且不予退费。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>8. 免责声明</h3>
            <ul className={styles.list}>
              <li>本平台不保证服务不会中断或完全无误，我们将尽最大努力确保服务的稳定性和准确性。</li>
              <li>因不可抗力（如服务器故障、网络中断等）导致的服务中断，本平台不承担赔偿责任。</li>
              <li>第三方支付服务（Stripe）的任何问题，请直接联系 Stripe 客服。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>9. 条款修改</h3>
            <p className={styles.text}>
              我们保留随时修改本服务条款的权利。修改后的条款将在本页面公布，继续使用本平台即表示您同意修改后的条款。重大变更将通过站内通知或邮件的方式告知用户。
            </p>
          </div>
        </section>

        {/* ========== 隐私政策 ========== */}
        <section className={styles.section} id="privacy">
          <div className={styles.sectionIcon}>
            <span className="material-icons-outlined">shield</span>
          </div>
          <h2 className={styles.sectionTitle}>隐私政策</h2>
          <p className={styles.updateDate}>最后更新日期：2025 年 6 月 1 日</p>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>1. 信息收集</h3>
            <p className={styles.text}>我们可能收集以下类型的信息：</p>
            <ul className={styles.list}>
              <li><strong>账户信息：</strong>注册时提供的用户名、邮箱地址、手机号码。</li>
              <li><strong>个人资料：</strong>您选择上传的头像图片。</li>
              <li><strong>使用数据：</strong>阅读记录、收藏的单词和句子、笔记内容、学习进度。</li>
              <li><strong>设备信息：</strong>浏览器类型、操作系统、IP 地址、设备标识符。</li>
              <li><strong>支付信息：</strong>付款相关的交易记录。请注意，您的银行卡信息由 Stripe 直接处理和存储，我们不会接触或保存您的完整卡号信息。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>2. 信息使用</h3>
            <p className={styles.text}>我们使用收集的信息用于以下目的：</p>
            <ul className={styles.list}>
              <li>提供和改进平台的核心服务功能。</li>
              <li>处理 VIP 会员的订阅和支付。</li>
              <li>个性化您的学习体验，如推荐适合的阅读内容。</li>
              <li>发送与服务相关的通知（如会员到期提醒）。</li>
              <li>分析用户行为以优化产品设计和用户体验。</li>
              <li>防止欺诈和滥用行为，保障平台安全。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>3. 信息共享</h3>
            <p className={styles.text}>我们不会将您的个人信息出售给第三方。在以下情况下，我们可能共享您的信息：</p>
            <ul className={styles.list}>
              <li><strong>支付处理：</strong>我们通过 Stripe 处理付款。Stripe 将根据其自身的<a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">隐私政策</a>处理您的支付信息。</li>
              <li><strong>法律要求：</strong>在法律要求或司法程序需要时，我们可能披露您的信息。</li>
              <li><strong>服务提供商：</strong>我们可能与帮助我们运营平台的第三方服务商共享有限信息（如云存储、分析服务），这些服务商受保密协议约束。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>4. Stripe 支付安全</h3>
            <ul className={styles.list}>
              <li>所有支付交易均通过 Stripe 安全处理，采用行业标准的 SSL/TLS 加密技术。</li>
              <li>Stripe 已通过 PCI DSS Level 1 认证，这是支付行业最高级别的安全标准。</li>
              <li>我们仅存储交易状态和订阅信息，不存储您的信用卡号码、CVV 或其他敏感支付数据。</li>
              <li>如需了解更多关于 Stripe 的安全措施，请访问 <a href="https://stripe.com/docs/security" target="_blank" rel="noopener noreferrer">Stripe 安全页面</a>。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>5. 数据存储与保护</h3>
            <ul className={styles.list}>
              <li>您的数据存储在安全的云服务器上，并采取合理的技术和管理措施进行保护。</li>
              <li>我们使用加密传输（HTTPS）来保护数据在传输过程中的安全。</li>
              <li>我们定期审查安全实践，以确保您的数据得到适当保护。</li>
              <li>尽管我们采取了合理的保护措施，但无法保证互联网传输的绝对安全性。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>6. Cookie 使用</h3>
            <p className={styles.text}>
              本平台使用 Cookie 和类似技术来维持您的登录状态、记住您的偏好设置（如主题颜色、深色模式）。这些是平台正常运行所必需的功能性 Cookie。我们不使用 Cookie 进行广告追踪。
            </p>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>7. 您的权利</h3>
            <p className={styles.text}>根据适用法律，您享有以下权利：</p>
            <ul className={styles.list}>
              <li><strong>访问权：</strong>您可以随时访问和查看您的个人信息。</li>
              <li><strong>更正权：</strong>您可以更新或更正您的账户信息。</li>
              <li><strong>删除权：</strong>您可以请求删除您的账户和相关数据。</li>
              <li><strong>数据导出：</strong>您可以请求导出您的个人数据。</li>
              <li>如需行使上述权利，请通过应用内反馈或邮件联系我们。</li>
            </ul>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>8. 未成年人保护</h3>
            <p className={styles.text}>
              本平台不面向 13 岁以下的儿童。如果我们发现收集了 13 岁以下儿童的个人信息，我们将尽快删除相关数据。如果您是未成年人的家长或监护人，并认为您的孩子向我们提供了个人信息，请联系我们。
            </p>
          </div>

          <div className={styles.block}>
            <h3 className={styles.blockTitle}>9. 隐私政策更新</h3>
            <p className={styles.text}>
              我们可能不时更新本隐私政策。更新后的政策将在本页面公布。我们建议您定期查看本页面以了解最新的隐私政策。如有重大变更，我们将通过站内通知的方式告知您。
            </p>
          </div>
        </section>

        {/* ========== 联系我们 ========== */}
        <section className={styles.contactSection}>
          <div className={styles.contactIcon}>
            <span className="material-icons-outlined">mail</span>
          </div>
          <h3 className={styles.contactTitle}>联系我们</h3>
          <p className={styles.text}>
            如果您对本服务条款或隐私政策有任何疑问，请通过以下方式联系我们：
          </p>
          <div className={styles.contactMethods}>
            <a className={styles.contactLink} href="mailto:xxx@gmail.com">
              <span className="material-icons-outlined">email</span>
              xxx@gmail.com
            </a>
            <p className={styles.contactNote}>我们将在 2 个工作日内回复您的邮件。</p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default TermsAndPrivacy;

